var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo } from 'react';
import { styled } from '@web/theme';
import { usePage } from '../../../ModulePage';
import { useBlockEdit } from '../../';
import { LazyLoadPlaceholder } from '../../../LazyLoadPlaceholder';
import { BlockImageEditor } from './BlockImageEditor';
import { Icon, useProgressiveImage } from '@web/utils';
import { faImage } from '@fortawesome/free-solid-svg-icons';
export var BlockImage = memo(function (_a) {
    var _b, _c;
    var backgroundImage = _a.backgroundImage, block = __rest(_a, ["backgroundImage"]);
    var loadedImage = useProgressiveImage(backgroundImage);
    var pageIsFetching = usePage().pageIsFetching;
    var blockEdit = useBlockEdit().blockEdit;
    var useHeight = ((_b = blockEdit.data) === null || _b === void 0 ? void 0 : _b.height) !== undefined ? (_c = blockEdit.data) === null || _c === void 0 ? void 0 : _c.height : block.height;
    return (React.createElement(React.Fragment, null,
        !loadedImage && React.createElement(Placeholder, null,
            React.createElement(Icon, { icon: faImage })),
        pageIsFetching
            ? React.createElement(Placeholder, null)
            : !blockEdit.enabled
                ? React.createElement(Img, { style: { backgroundImage: "url(" + loadedImage + ")", width: '100%', height: useHeight + "px" || 'auto' } })
                : React.createElement(BlockImageEditor, { image: backgroundImage, height: useHeight || 100 })));
});
export var Img = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tmin-height: 100px;\n\tdisplay: block;\n\tflex: none;\n\t\n\ttransition: height .25s;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  will-change: opacity;\n  object-fit: cover;\n"], ["\n\tmin-height: 100px;\n\tdisplay: block;\n\tflex: none;\n\t\n\ttransition: height .25s;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  will-change: opacity;\n  object-fit: cover;\n"])));
export var Placeholder = styled(LazyLoadPlaceholder)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 48px;\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 48px;\n"])));
var templateObject_1, templateObject_2;
